import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {merge} from "rxjs";
import {ColumnFilter} from "../../../search-table/columns-filters/column-filters.service";
import {VoTableColumnFiltersService} from "../../column-filters/vo-table-column-filters.service";
import {filter, tap} from "rxjs/operators";
import {Column} from "asax-common";

@Component({
  selector: 'asax-result-table-vo-table-column-header-container',
  templateUrl: './vo-table-column-header-container.component.html'
})
export class VoTableColumnHeaderContainerComponent implements OnInit {
  @Input() column: Column;
  @Input() sortDir: any;

  @Output() outSort = new EventEmitter<any>();

  constructor(private readonly columnFiltersService: VoTableColumnFiltersService,
              private readonly changeDetectorRef: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    merge(
      this.columnFiltersService.columnFiltersRemoved(),
      this.columnFiltersService.columnFilterRemoved(this.column?.id)
    ).pipe(
      tap(value => (this.column = {...this.column, value: undefined})),
      tap(() => this.changeDetectorRef.markForCheck())
    ).subscribe();

    this.columnFiltersService.getColumnFilterIsDisabled(this.column?.id).pipe(
      filter(isDisabled => isDisabled !== this.column.isDisabled),
      tap(isDisabled => (this.column = {...this.column, isDisabled})),
      tap(() => this.changeDetectorRef.markForCheck())
    ).subscribe();
  }

  emitSort(): void {
    this.outSort.emit();
  }

  onColumnFilter(columnFilter: ColumnFilter): void {
    this.columnFiltersService.upsertColumnFilter(columnFilter);
  }
}
